export class BorrowerAndAgentMessageModel {
  applicationId:	number;
  loanDocTaskId:	number | undefined;
  messageText:	string | undefined;
}
